import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
import styles from './CalendarCollapsedScheduleEvent.module.scss';
import { ServiceScheduleCollapseAbleEvent } from '../../../Workplace/Interfaces/ServiceScheduleEvent.interface';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';

interface Props {
	event: {
		backgroundColor: string;
		extendedProps: ServiceScheduleCollapseAbleEvent;
	};
}

const CalendarCollapsedScheduleEvent: React.FC<Props> = ({ event }) => {
	const eventRef = useRef<HTMLDivElement>(null);
	const [isExpanded, setIsExpanded] = useState(false);
	const [expandedPosition, setExpandedPosition] = useState<object>({
		left: 0,
		top: 0,
	});
	const data = event.extendedProps;

	const handleCalculatePosition = () => {
		// @ts-ignore
		const event = eventRef.current?.getBoundingClientRect();

		let positionX = event.x;
		let positionY = event.y;

		setExpandedPosition(prevValue => {
			return {
				...prevValue,
				top: positionY + 50,
				left: positionX,
				right: 'auto',
				bottom: 'auto',
				width: event.width,
			};
		});
	};

	const handleMouseEnter = () => {
		if (event.extendedProps.otherCount > 0) {
			handleCalculatePosition();
			setIsExpanded(true);
		}
	};

	const handleMouseLeave = () => {
		setIsExpanded(false);
	};

	const content = (
		<div className={styles.expanded} style={expandedPosition}>
			{data.items.map(item => (
				<div
					className={styles.item}
					style={{ backgroundColor: event.backgroundColor }}>
					<div>{item.shift.label}</div>
					{item.workers.map(worker => (
						<div>{worker.name}</div>
					))}
				</div>
			))}
		</div>
	);

	// @ts-ignore
	const modalRoot = document.getElementById('modal-root');
	const portal = ReactDOM.createPortal(content, modalRoot);

	return (
		<div className={styles.wrapper} ref={eventRef}>
			<div
				className={styles.label}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}>
				{data.label}{' '}
				{event.extendedProps.otherCount > 0 && (
					<LinkButton
						title={` +${event.extendedProps.otherCount}`}
						theme={Theme.BLUE}
					/>
				)}
			</div>
			{isExpanded && portal}
		</div>
	);
};

export default CalendarCollapsedScheduleEvent;
